import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import PurchaseNotification from "./components/PurchaseNotification";
import HomePage from "./pages/HomePage";
import ShopPage from "./pages/ShopPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import CheckoutPage from "./pages/CheckoutPage";
import OrderConfirmationPage from "./pages/OrderConfirmationPage";
import ReviewsPage from "./pages/ReviewsPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import MarketplacePage from "./pages/MarketplacePage";
import MarketplaceProductPage from "./pages/MarketplaceProductPage";
import AdminPage from "./pages/AdminPage";
import RetailPartnerPage from "./pages/RetailPartnerPage";
import ConsignmentAgreementPage from "./pages/ConsignmentAgreementPage";
import WholesaleAgreementPage from "./pages/WholesaleAgreementPage";

function App() {
  return (
    <CartProvider>
      <div className="App min-h-screen bg-void">
        <BrowserRouter>
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/shop" element={<ShopPage />} />
              <Route path="/product/:id" element={<ProductDetailPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/order-confirmation" element={<OrderConfirmationPage />} />
              <Route path="/reviews" element={<ReviewsPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/marketplace" element={<MarketplacePage />} />
              <Route path="/marketplace/product/:id" element={<MarketplaceProductPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/retailpartnership" element={<RetailPartnerPage />} />
              <Route path="/consignment-agreement" element={<ConsignmentAgreementPage />} />
              <Route path="/wholesale-agreement" element={<WholesaleAgreementPage />} />
            </Routes>
          </main>
          <Footer />
          <PurchaseNotification />
        </BrowserRouter>
        <Toaster 
          position="top-center" 
          richColors 
          theme="dark"
          toastOptions={{
            style: {
              background: '#0a0a0a',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              color: '#ffffff',
            },
          }}
        />
      </div>
    </CartProvider>
  );
}

export default App;
